module.exports = __webpack_public_path__ + "img/icon_mute_color.538560c4.svg";